module.exports = __webpack_public_path__ + "static/media/level4Grey.ea9dc0e6.svg";